import { useState } from 'react';
import { useParams } from 'react-router-dom';
import useCampaignNavigate from 'hooks/useCampaignNavigate';
import { ITERATION_STATUS } from 'schemas/CampaignApiDetails.schema';
import { API_UPDATE_ITERATION_ERROR } from 'constants/errorMessages';
import ApiErrorDetails from 'components/ApiErrorDetails';
import useUpdateIterationStatus from 'queries/mutate/updateIterationStatus';
import { Button } from 'nhsuk-react-components';
import Back from 'components/Back';

function ArchiveIterationConfirmationPage() {
  const { teamId, campaignId, iterationId } = useParams<{ teamId: string; campaignId: string; iterationId: string }>();
  const [statusUpdateError, setStatusUpdateError] = useState<{ message: string } | null>(null);
  const { navigateToCampaign } = useCampaignNavigate();
  const updateIterationStatus = useUpdateIterationStatus();

  const handleConfirm = async () => {
    try {
      await updateIterationStatus.mutateAsync({
        teamId: teamId!,
        campaignId: campaignId!,
        iterationId: iterationId!,
        status: ITERATION_STATUS.ARCHIVED,
      });
      navigateToCampaign('summary');
    } catch {
      setStatusUpdateError({ message: API_UPDATE_ITERATION_ERROR });
    }
  };

  return (
    <div className="archive-iteration-confirmation-page">
      <div className="nhsuk-u-margin-top-6 nhsuk-u-margin-bottom-6">
        <Back label="Iteration summary" />
      </div>
      <h2>Archive iteration</h2>
      <p>
        Archiving this iteration will remove it from view.
      </p>
      <p>
        The iteration and its information will not be deleted. However, it will no longer be visible in SPI to users who would normally have access to it.
      </p>
      <p>
        If you need to access the iteration again, you will need to ask a SPI administrator to restore it.
      </p>
      <p>
        Before archiving the iteration, make sure any users who may need access to it are aware that it will no longer be visible.
      </p>
      <p>
        Only archive the iteration if you are sure it should no longer be available to users.
      </p>

      <ApiErrorDetails apiError={statusUpdateError} />

      <Button warning onClick={handleConfirm}>
        Yes, archive iteration
      </Button>
    </div>
  );
}

export default ArchiveIterationConfirmationPage;
